/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import styles from '../../styles/Layout.module.css';
import Loading from '../../components/loading/Loading';
import FlashContext from '../../components/contexts/FlashContext';
import ContractAwardTable from '../../components/tables/contractAwards/ContractAwardsTable';
import api from '../../service/axios/api';
import routing from '../../service/routes/routing';
import MyButton from '../../components/button/MyButton';
import PermissionComponent from '../../components/permissionComponent/PermissionComponent';
import UserRoles from '../../service/acl/UserRoles';
import EditAddressModal from './editAddress/EditAddressModal'

export default function ContractAwards() {
  const history = useHistory();
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const [loading, setLoading] = useState(false);
  const [chipData, setChipData] = useState([]);
  const [data, setData] = useState([]);
  const [contract, setContract] = useState("");
  const [payerName, setPayerName] = useState("");
  const [payerDoc, setPayerDoc] = useState("");
  const [awardeeName, setAwardeeName] = useState("");
  const [awardeeDoc, setAwardeeDoc] = useState("");
  const [page, setPage] = useState(0);
  const [itens, setItens] = useState(10);
  const [total, setTotal] = useState(0);
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const [selectedIndividual, setSelectedIndividual] = useState(null);
  const [selectedCaiId, setSelectedCaiId] = useState(null);


  const filterChipData = (specificChips) => {
    const currentChips = specificChips || chipData;

    let contr = '';
    let payerN = '';
    let payerD = '';
    let awardeeN = '';
    let awardeeD = '';

    if(currentChips.length > 0 ){
      currentChips.forEach(chip =>{
        if(chip.byType === 'contractId'){
          contr = chip.label;
        }
        if(chip.byType === 'payerName'){
          payerN = chip.label;
        }
        if(chip.byType === 'payerDoc'){
          payerD = chip.label;
        }
        if(chip.byType === 'awardeeName'){
          awardeeN = chip.label;
        }
        if(chip.byType === 'awardeeDoc'){
          awardeeD = chip.label;
        }
      });
    }

    return { contr, payerN, payerD, awardeeN, awardeeD}
    // setContract(contr);
    // setPayerName(payerN);
    // setPayerDoc(payerD);
    // setAwardeeName(awardeeN);
    // setAwardeeDoc(awardeeD);
  };

  const search = async (newChipsFromDirectSearch) => {
    setLoading(true);
    const cancel = new AbortController();

    try {
      const filtered = filterChipData(newChipsFromDirectSearch);
      setContract(filtered.contr);
      setPayerName(filtered.payerN);
      setPayerDoc(filtered.payerD);
      setAwardeeName(filtered.awardeeN);
      setAwardeeDoc(filtered.awardeeD);

      const filters = {
        contract: filtered.contr,
        payerName: filtered.payerN,
        payerDoc: filtered.payerD,
        awardeeName: filtered.awardeeN,
        awardeeDoc: filtered.awardeeD,
      };
      const contractAwards = await api.contract.getContractAwards(cancel, itens, page + 1, filters);

      setData(contractAwards.docs);
      setTotal(contractAwards.total);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const removeIndividual = async (doc, contractId, status) => {
    try {
      const res = await api.contract.updateAwardIndividualsStatus(contractId, doc, status);
      notifySuccess(res.message);
    } catch (error) {
      notifyError(error.message);
    } finally {
      search();
    }
  };


  const handleOpenAddressModal = (individual, idCai) => {
    setSelectedIndividual(individual);
    setSelectedCaiId(idCai);
    setAddressModalOpen(true);
  };

  const handleCloseAddressModal = () => {
    setAddressModalOpen(false);
    setSelectedIndividual(null);
    setSelectedCaiId(null);
  };


  useEffect(() => {
    search();
  }, [itens, page]);
  
  useEffect(() => {
    filterChipData();
  }, [chipData]);

  return (
    <>
      <Loading open={loading} msg={t('contractAwards.searchMsg')} />
      <div className="col-sm-12" style={{ marginTop: 50 }}>
        <div
          className="col-sm-12"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <div>
            <p
              className={styles.textMenu}
              onKeyDown={() => history.push(routing.dashboard)}
              onClick={() => history.push(routing.dashboard)}
            >
              {t('initialMenu')}
            </p>
          </div>
        </div>
        <div
          className="col-sm-12"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h4 className={styles.textTitle}>{t('contractAwards.label')}</h4>
        </div>
      </div>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        />
        <Grid item xs={12} sm={12}>
          <ContractAwardTable
            data={data}
            page={page}
            setPage={setPage}
            itens={itens}
            setItens={setItens}
            chipData={chipData}
            setChipData={setChipData}
            find={search}
            total={total}
            disableIndividual={removeIndividual}
            onEditAddress={handleOpenAddressModal}
          />
        </Grid>
      </Grid>
      <EditAddressModal
        open={addressModalOpen}
        onClose={handleCloseAddressModal}
        individual={selectedIndividual}
        idCai={selectedCaiId}
        onSuccess={search}
        notifySuccess={notifySuccess}
        notifyError={notifyError}
      />
    </>
  );
}
